import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./styles/globals.css";

// Plausible analytics — only loaded when VITE_PLAUSIBLE_DOMAIN is set at build time.
const _plausibleDomain = import.meta.env.VITE_PLAUSIBLE_DOMAIN;
if (_plausibleDomain) {
  window.plausible = window.plausible || function () {
    (window.plausible.q = window.plausible.q || []).push(arguments);
  };
  const _s = document.createElement("script");
  _s.defer = true;
  _s.setAttribute("data-domain", _plausibleDomain);
  _s.src = "https://plausible.io/js/script.js";
  document.head.appendChild(_s);
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
